(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cielohuk-localization-status"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('cielohuk-localization-status');
    if (!dialog) return;

    const message = dialog.querySelector('[role="status"]');
    const dismiss = dialog.querySelector('[data-localization-dismiss]');
    const current = {
      language_code: dialog.dataset.currentLanguage,
      country_code: dialog.dataset.currentCountry
    };
    const languageFeedback = new Map([
      ['ja', ['日本語に切り替えています…', '切り替え中の表示を閉じる']],
      ['en', ['Switching to English…', 'Close progress message']],
      ['es', ['Cambiando a español…', 'Cerrar mensaje de progreso']],
      ['de', ['Wechsel zu Deutsch…', 'Fortschrittsmeldung schließen']],
      ['fr', ['Passage au français…', 'Fermer le message de progression']],
      ['pt-br', ['Mudando para português…', 'Fechar mensagem de progresso']],
      ['nl', ['Overschakelen naar Nederlands…', 'Voortgangsbericht sluiten']]
    ]);
    let pendingForm = null;
    let restoredFromCache = false;

    const reset = () => {
      if (pendingForm) pendingForm.removeAttribute('aria-busy');
      pendingForm = null;
      if (dialog.open) dialog.close();
      document.querySelectorAll('.shopify-localization-form hdt-richlist').forEach(list => {
        const option = list.querySelector('button[name]');
        const value = option && current[option.name];
        if (value) {
          list.setAttribute('selected', value);
          list.querySelectorAll('button[name]').forEach(button => {
            button.setAttribute('aria-selected', String(button.value === value));
          });
        }
      });
    };

    document.addEventListener('submit', event => {
      const form = event.target;
      const button = event.submitter;
      if (event.defaultPrevented || !form.matches('.shopify-localization-form') || !button || !(button.name in current)) return;
      if (pendingForm || (!restoredFromCache && button.value === current[button.name])) {
        event.preventDefault();
        return;
      }

      const changingLanguage = button.name === 'language_code';
      const language = button.value.toLowerCase();
      const feedback = changingLanguage && (languageFeedback.get(language) || languageFeedback.get(language.split('-')[0]));
      dialog.lang = feedback ? button.value : current.language_code;
      message.textContent = changingLanguage
        ? (feedback ? feedback[0] : dialog.dataset.languageOther)
        : dialog.dataset.currencyMessage.replace('__currency__', button.dataset.name || button.value);
      dismiss.setAttribute('aria-label', feedback ? feedback[1] : dialog.dataset.dismissOther);
      pendingForm = form;
      form.setAttribute('aria-busy', 'true');
      dialog.showModal();
    });

    dismiss.addEventListener('click', reset);
    dialog.addEventListener('close', reset);
    window.addEventListener('pageshow', event => {
      if (event.persisted) {
        restoredFromCache = true;
        reset();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cielohuk-wishlist-root"] && !Shopify.designMode) return;
  try {
    (() => {
    "use strict";

    const root = document.querySelector("[data-cielohuk-wishlist-root]");
    if (!root || root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";

    function sameOriginRootPath(value) {
      if (typeof value !== "string" || value.length === 0) return null;
      try {
        const url = new URL(value, window.location.origin);
        if (url.origin !== window.location.origin) return null;
        const path = url.pathname || "/";
        return path.endsWith("/") ? path : `${path}/`;
      } catch {
        return null;
      }
    }

    const storefrontRoot =
      sameOriginRootPath(window.Shopify?.routes?.root) ||
      sameOriginRootPath(root.dataset.rootPath) ||
      "/";

    const drawer = document.getElementById("CielohukWishlistDrawer");
    const listContainer = drawer?.querySelector("[data-cielohuk-wishlist-lists]");
    const drawerStatus = drawer?.querySelector("[data-cielohuk-wishlist-status]");
    const retryButton = drawer?.querySelector("[data-cielohuk-wishlist-retry]");
    const globalStatus = root.querySelector("[data-cielohuk-wishlist-global-status]");
    const translationNode = root.querySelector("[data-cielohuk-wishlist-translations]");
    const strings = translationNode ? JSON.parse(translationNode.textContent || "{}") : {};
    const defaultApiBase = "/apps/cielohuk-benefits/v1/wishlist";
    const apiBase = (() => {
      try {
        const url = new URL(root.dataset.apiBase || defaultApiBase, window.location.origin);
        if (url.origin !== window.location.origin || !url.pathname.startsWith("/apps/")) return defaultApiBase;
        return url.pathname.replace(/\/+$/, "");
      } catch {
        return defaultApiBase;
      }
    })();
    const legacyGuestTokenKey = "cielohuk:wishlist:guest-token:v1";
    const guestSessionKey = "cielohuk:wishlist:guest-session:v2";
    const guestRevisionKey = "cielohuk:wishlist:guest-revision:v1";
    const pageSize = 25;
    const productCache = new Map();
    const initialGuestSession = readGuestSession();
    const state = {
      authenticated: root.dataset.authenticated === "true",
      ownerType: null,
      guestToken: initialGuestSession.token,
      guestTokenVersion: initialGuestSession.version,
      guestDefaultListId: initialGuestSession.defaultListId,
      revision: 0,
      defaultListId: null,
      lists: [],
      membership: new Map(),
      counts: new Map(),
      pendingProductToggles: new Map(),
      cartSelections: new Map(),
      membershipGenerations: new Map(),
      countGenerations: new Map(),
      membershipRefreshProductGids: new Set(),
      ownerEpoch: 0,
      ready: null,
      opener: null,
      focusedProductGid: null,
      restoreFocus: true,
      mutationQueue: Promise.resolve(),
      hydrateTimer: null,
      hydratePromise: null,
      hydrateRequested: false,
      listLoadPromise: null,
      listLoadSerial: 0,
      listsRevision: -1,
      listsLoadedAt: 0,
      drawerLoadPromise: null,
      refreshPromise: null,
      refreshRequested: false,
      refreshMinimumRevision: 0,
      refreshForceAfterSerial: null,
      externalUpdateRevision: -1,
      externalProductRevisions: new Map(),
      pageNumber: 1,
    };

    class WishlistApiError extends Error {
      constructor(status, code, message, details) {
        super(message);
        this.name = "WishlistApiError";
        this.status = status;
        this.code = code;
        this.details = details || {};
      }
    }

    class WishlistOwnerChangedError extends Error {
      constructor() {
        super("Wishlist owner changed while the request was in flight");
        this.name = "WishlistOwnerChangedError";
      }
    }

    function readStorage(key) {
      try {
        return window.localStorage.getItem(key);
      } catch {
        return null;
      }
    }

    function writeStorage(key, value) {
      try {
        if (value === null) window.localStorage.removeItem(key);
        else window.localStorage.setItem(key, String(value));
      } catch {
        return;
      }
    }

    function readGuestSession() {
      const stored = readStorage(guestSessionKey);
      if (stored) {
        try {
          const value = JSON.parse(stored);
          if (
            typeof value?.token === "string" &&
            /^[A-Za-z0-9_-]{43}$/.test(value.token) &&
            Number.isSafeInteger(value.version) &&
            value.version >= 1
          ) {
            return {
              token: value.token,
              version: value.version,
              defaultListId:
                typeof value.defaultListId === "string" && value.defaultListId.length > 0
                  ? value.defaultListId
                  : null,
            };
          }
        } catch {
          writeStorage(guestSessionKey, null);
        }
      }
      const legacyToken = readStorage(legacyGuestTokenKey);
      if (legacyToken && /^[A-Za-z0-9_-]{43}$/.test(legacyToken)) {
        return { token: legacyToken, version: 0, defaultListId: null };
      }
      return { token: null, version: 0, defaultListId: null };
    }

    function applyGuestSession({ token, version, defaultListId }) {
      state.guestToken = token;
      state.guestTokenVersion = version;
      state.guestDefaultListId = defaultListId;
    }

    function persistGuestSession(token, version, defaultListId, previousToken) {
      const nextVersion = Number(version);
      if (
        typeof token !== "string" ||
        !/^[A-Za-z0-9_-]{43}$/.test(token) ||
        !Number.isSafeInteger(nextVersion) ||
        nextVersion < 1 ||
        typeof defaultListId !== "string" ||
        defaultListId.length === 0
      ) {
        throw new Error("Invalid guest Wishlist session response");
      }
      const next = { token, version: nextVersion, defaultListId };
      const current = readGuestSession();
      if (!current.token) {
        if (previousToken) {
          applyGuestSession(current);
          return "cleared";
        }
      } else if (current.token === token && current.version === nextVersion) {
        if (current.defaultListId && current.defaultListId !== defaultListId) {
          applyGuestSession(current);
          return "owner-changed";
        }
      } else if (current.defaultListId && current.defaultListId !== defaultListId) {
        applyGuestSession(current);
        return "owner-changed";
      } else if (current.defaultListId === defaultListId) {
        if (current.version > nextVersion) {
          applyGuestSession(current);
          return "same-owner-newer";
        }
        if (current.version === nextVersion) {
          applyGuestSession(current);
          return "owner-changed";
        }
      } else if (
        !current.defaultListId &&
        state.guestDefaultListId === defaultListId &&
        current.version > nextVersion
      ) {
        const enriched = { ...current, defaultListId };
        writeStorage(guestSessionKey, JSON.stringify(enriched));
        applyGuestSession(enriched);
        return "same-owner-newer";
      } else if (current.token !== previousToken) {
        applyGuestSession(current);
        return "owner-changed";
      }
      writeStorage(guestSessionKey, JSON.stringify(next));
      writeStorage(legacyGuestTokenKey, null);
      applyGuestSession(next);
      return "response";
    }

    function clearGuestSession() {
      state.guestToken = null;
      state.guestTokenVersion = 0;
      state.guestDefaultListId = null;
      writeStorage(guestSessionKey, null);
      writeStorage(legacyGuestTokenKey, null);
      writeStorage(guestRevisionKey, null);
    }

    function formatText(template, values = {}) {
      return Object.entries(values).reduce((text, [key, value]) => {
        const placeholder = ["{", "{", ` ${key} `, "}", "}"].join("");
        return text.replaceAll(placeholder, String(value));
      }, template || "");
    }

    function setStatus(message, isError = false) {
      if (globalStatus) globalStatus.textContent = message;
      if (drawerStatus) {
        drawerStatus.textContent = message;
        drawerStatus.dataset.state = isError ? "error" : "ready";
      }
      if (retryButton) retryButton.hidden = !isError;
    }

    function messageForError(error) {
      if (error instanceof WishlistApiError) {
        if (error.code === "max_items_exceeded") return strings.maxItems;
        if (error.code === "max_lists_exceeded") return strings.maxLists;
        if (error.code === "invalid_list_name" || error.code === "list_name_exists") return strings.listNameError;
        if (error.code === "product_unavailable") return strings.productUnavailable;
        if (error.code === "product_handle_mismatch") return strings.productChanged;
      }
      return strings.unavailable;
    }

    function idempotencyKey(prefix) {
      return `${prefix}:${crypto.randomUUID()}`;
    }

    async function request(path, options = {}) {
      const headers = new Headers({ accept: "application/json" });
      if (options.body !== undefined) headers.set("content-type", "application/json");
      const defaultToken = state.ownerType === "customer" ? null : state.guestToken;
      const token = options.token === undefined ? defaultToken : options.token;
      if (token) headers.set("x-cielohuk-guest-token", token);
      if (options.idempotencyKey) headers.set("idempotency-key", options.idempotencyKey);
      const response = await fetch(`${apiBase}${path}`, {
        method: options.method || "GET",
        headers,
        body: options.body === undefined ? undefined : JSON.stringify(options.body),
        credentials: "same-origin",
        cache: "no-store",
      });
      let payload = null;
      try {
        payload = await response.json();
      } catch {
        payload = null;
      }
      if (!response.ok || !payload || payload.schemaVersion !== 1) {
        const error = payload?.error || {};
        throw new WishlistApiError(
          response.status,
          error.code || "invalid_response",
          error.message || strings.unavailable,
          error.details,
        );
      }
      return payload.data;
    }

    function persistGuestRevision() {
      if (state.ownerType === "guest") writeStorage(guestRevisionKey, state.revision);
    }

    function commitRevision(revision) {
      if (Number.isSafeInteger(revision) && revision >= 0) {
        state.revision = Math.max(state.revision, revision);
      }
      return state.revision;
    }

    function normalizeProductGids(productGids) {
      return [...new Set(
        (Array.isArray(productGids) ? productGids : [])
          .filter((productGid) => typeof productGid === "string" && productGid.length > 0),
      )];
    }

    function generationFor(generations, productGid) {
      return generations.get(productGid) || 0;
    }

    function bumpGeneration(generations, productGid) {
      const next = generationFor(generations, productGid) + 1;
      generations.set(productGid, next);
      return next;
    }

    function invalidateMembership(productGids, rebuildFromLists = false) {
      for (const productGid of normalizeProductGids(productGids)) {
        bumpGeneration(state.membershipGenerations, productGid);
        state.membership.delete(productGid);
        if (rebuildFromLists) state.membershipRefreshProductGids.add(productGid);
      }
    }

    function invalidateCounts(productGids) {
      for (const productGid of normalizeProductGids(productGids)) {
        bumpGeneration(state.countGenerations, productGid);
        state.counts.delete(productGid);
      }
    }

    function setKnownMembership(productGid, listIds) {
      if (!productGid) return;
      bumpGeneration(state.membershipGenerations, productGid);
      state.membershipRefreshProductGids.delete(productGid);
      state.membership.set(productGid, Array.isArray(listIds) ? [...new Set(listIds)] : []);
    }

    function setKnownCount(productGid, count) {
      if (!productGid) return;
      bumpGeneration(state.countGenerations, productGid);
      if (Number.isSafeInteger(count) && count >= 0) state.counts.set(productGid, count);
      else state.counts.delete(productGid);
    }

    function visibleProductGids() {
      return normalizeProductGids(
        [...document.querySelectorAll("[data-cielohuk-wishlist-toggle]")]
          .map((button) => button.dataset.productGid),
      );
    }

    function resetOwnerState() {
      state.ownerEpoch += 1;
      state.pendingProductToggles.clear();
      state.cartSelections.clear();
      state.ownerType = null;
      state.revision = 0;
      state.defaultListId = null;
      state.lists = [];
      state.membership = new Map();
      state.membershipGenerations = new Map();
      state.membershipRefreshProductGids = new Set();
      state.ready = null;
      state.listLoadPromise = null;
      state.listLoadSerial = 0;
      state.listsRevision = -1;
      state.listsLoadedAt = 0;
      state.drawerLoadPromise = null;
      state.refreshMinimumRevision = 0;
      state.refreshForceAfterSerial = null;
      state.externalUpdateRevision = -1;
      state.externalProductRevisions = new Map();
      updateOwnerTotals();
    }

    async function mergeGuestWishlist(token, initialGuestRevision, ownerEpoch) {
      let customerRevision = state.revision;
      let guestRevision = Number.isSafeInteger(initialGuestRevision) ? initialGuestRevision : 0;
      for (let attempt = 0; attempt < 2; attempt += 1) {
        if (ownerEpoch !== state.ownerEpoch) throw new WishlistOwnerChangedError();
        try {
          const merged = await request("/merge", {
            method: "POST",
            token,
            idempotencyKey: idempotencyKey("wishlist-merge"),
            body: {
              expectedCustomerRevision: customerRevision,
              expectedGuestRevision: guestRevision,
            },
          });
          if (ownerEpoch !== state.ownerEpoch) throw new WishlistOwnerChangedError();
          commitRevision(merged.revision);
          clearGuestSession();
          return;
        } catch (error) {
          if (
            error instanceof WishlistApiError &&
            error.code === "stale_revision" &&
            attempt === 0
          ) {
            customerRevision = Number(error.details.currentCustomerRevision);
            guestRevision = Number(error.details.currentGuestRevision);
            continue;
          }
          if (
            error instanceof WishlistApiError &&
            ["guest_session_invalid", "guest_session_required"].includes(error.code)
          ) {
            clearGuestSession();
            return;
          }
          throw error;
        }
      }
    }

    async function requestSession(token) {
      return request("/session", {
        method: "POST",
        token: state.authenticated ? null : token,
        body: {},
      });
    }

    async function openSession(ownerEpoch) {
      const previousToken = state.guestToken;
      const previousGuestRevision = Number(readStorage(guestRevisionKey));
      let session;
      try {
        session = await requestSession(previousToken);
      } catch (error) {
        if (
          !state.authenticated &&
          previousToken &&
          error instanceof WishlistApiError &&
          ["guest_session_invalid", "guest_session_required"].includes(error.code)
        ) {
          clearGuestSession();
          session = await requestSession(null);
        } else {
          throw error;
        }
      }
      if (ownerEpoch !== state.ownerEpoch) throw new WishlistOwnerChangedError();
      if (session.guestToken) {
        const guestSessionResult = persistGuestSession(
          session.guestToken,
          session.guestTokenVersion,
          session.defaultListId,
          previousToken,
        );
        if (guestSessionResult === "owner-changed") {
          resetOwnerState();
          return ensureReady();
        }
        if (guestSessionResult === "cleared") {
          resetOwnerState();
          throw new WishlistOwnerChangedError();
        }
      }
      state.ownerType = session.ownerType;
      commitRevision(session.revision);
      state.defaultListId = session.defaultListId;
      persistGuestRevision();
      if (session.authenticated && previousToken) {
        try {
          await mergeGuestWishlist(previousToken, previousGuestRevision, ownerEpoch);
        } catch (error) {
          if (error instanceof WishlistOwnerChangedError) throw error;
          setStatus(messageForError(error), true);
        }
      }
      if (ownerEpoch !== state.ownerEpoch) throw new WishlistOwnerChangedError();
      await loadLists(state.revision, { force: true });
    }

    async function ensureReady(force = false) {
      if (!state.ready || force) {
        const ownerEpoch = state.ownerEpoch;
        const pending = openSession(ownerEpoch).catch((error) => {
          if (state.ready === pending) state.ready = null;
          throw error;
        });
        state.ready = pending;
      }
      return state.ready;
    }

    function rebuildMembershipFromLists() {
      const knownProductGids = new Set([
        ...state.membership.keys(),
        ...state.membershipRefreshProductGids,
      ]);
      for (const list of state.lists) {
        for (const item of list.items || []) {
          if (item.productGid) knownProductGids.add(item.productGid);
        }
      }
      const membership = new Map();
      for (const productGid of knownProductGids) {
        bumpGeneration(state.membershipGenerations, productGid);
        membership.set(productGid, []);
      }
      for (const list of state.lists) {
        for (const item of list.items || []) {
          const listIds = membership.get(item.productGid) || [];
          if (!listIds.includes(list.id)) listIds.push(list.id);
          membership.set(item.productGid, listIds);
        }
      }
      state.membership = membership;
      state.membershipRefreshProductGids.clear();
      updateOwnerTotals();
    }

    function membershipSnapshotFromLists(lists = state.lists) {
      const snapshot = new Map();
      for (const list of Array.isArray(lists) ? lists : []) {
        for (const item of list.items || []) {
          if (!item.productGid) continue;
          const listIds = snapshot.get(item.productGid) || [];
          if (!listIds.includes(list.id)) listIds.push(list.id);
          snapshot.set(item.productGid, listIds);
        }
      }
      for (const [productGid, listIds] of snapshot) {
        snapshot.set(productGid, [...listIds].sort());
      }
      return snapshot;
    }

    function changedMembershipProductGids(previous, current) {
      const productGids = new Set([...previous.keys(), ...current.keys()]);
      return [...productGids].filter((productGid) => {
        const before = previous.get(productGid) || [];
        const after = current.get(productGid) || [];
        return before.length !== after.length || before.some((listId, index) => listId !== after[index]);
      });
    }

    function takeUnprocessedExternalProductGids(productGids, revision) {
      const normalized = normalizeProductGids(productGids);
      if (!Number.isSafeInteger(revision) || revision < 0) return normalized;
      return normalized.filter((productGid) => {
        const previousRevision = state.externalProductRevisions.get(productGid);
        if (Number.isSafeInteger(previousRevision) && previousRevision >= revision) return false;
        state.externalProductRevisions.set(productGid, revision);
        return true;
      });
    }

    function startListLoad() {
      const ownerEpoch = state.ownerEpoch;
      state.listLoadSerial += 1;
      const pending = request("/lists")
        .then((data) => {
          if (ownerEpoch !== state.ownerEpoch) throw new WishlistOwnerChangedError();
          const revision = Number(data.revision);
          if (!Number.isSafeInteger(revision) || revision < 0) {
            throw new WishlistApiError(502, "invalid_response", strings.unavailable);
          }
          if (revision < state.revision || revision < state.listsRevision) return data;
          commitRevision(revision);
          state.listsRevision = revision;
          state.lists = Array.isArray(data.lists) ? data.lists : [];
          const defaultList = state.lists.find((list) => list.isDefault);
          if (defaultList) state.defaultListId = defaultList.id;
          rebuildMembershipFromLists();
          persistGuestRevision();
          state.listsLoadedAt = Date.now();
          return data;
        })
        .finally(() => {
          if (state.listLoadPromise === pending) state.listLoadPromise = null;
        });
      state.listLoadPromise = pending;
      return pending;
    }

    async function loadLists(minimumRevision = 0, options = {}) {
      const ownerEpoch = state.ownerEpoch;
      const requiredRevision = Number.isSafeInteger(minimumRevision) && minimumRevision >= 0
        ? minimumRevision
        : 0;
      const forceAfterSerial = Number.isSafeInteger(options.forceAfterSerial)
        ? options.forceAfterSerial
        : options.force === true
          ? state.listLoadSerial
          : null;
      for (let attempt = 0; attempt < 4; attempt += 1) {
        if (ownerEpoch !== state.ownerEpoch) throw new WishlistOwnerChangedError();
        const targetRevision = Math.max(requiredRevision, state.revision);
        const requiresForcedLoad = forceAfterSerial !== null && state.listLoadSerial <= forceAfterSerial;
        let pending = state.listLoadPromise;
        if (!pending && (requiresForcedLoad || state.listsRevision < targetRevision)) {
          pending = startListLoad();
        }
        if (pending) await pending;
        if (ownerEpoch !== state.ownerEpoch) throw new WishlistOwnerChangedError();
        const forcedLoadCompleted = forceAfterSerial === null || state.listLoadSerial > forceAfterSerial;
        if (forcedLoadCompleted && state.listsRevision >= Math.max(requiredRevision, state.revision)) {
          return { revision: state.listsRevision, lists: state.lists };
        }
      }
      throw new WishlistApiError(409, "stale_revision", strings.unavailable);
    }

    function updateOwnerTotals() {
      const total = [...state.membership.values()].filter(
        (listIds) => Array.isArray(listIds) && listIds.length > 0,
      ).length;
      document.querySelectorAll("[data-cielohuk-wishlist-total]").forEach((node) => {
        node.textContent = String(total);
      });
      document.querySelectorAll("[data-cielohuk-wishlist-drawer-summary]").forEach((node) => {
        node.textContent = formatText(strings.pageSummary, { count: total });
      });
    }

    function chunks(values, size) {
      const output = [];
      for (let index = 0; index < values.length; index += size) {
        output.push(values.slice(index, index + size));
      }
      return output;
    }

    async function readVisibleMembership(productGids) {
      const ownerEpoch = state.ownerEpoch;
      for (const productChunk of chunks(normalizeProductGids(productGids), 250)) {
        const generations = new Map(
          productChunk.map((productGid) => [
            productGid,
            generationFor(state.membershipGenerations, productGid),
          ]),
        );
        const data = await request("/membership", {
          method: "POST",
          body: { products: productChunk },
        });
        if (ownerEpoch !== state.ownerEpoch) throw new WishlistOwnerChangedError();
        commitRevision(data.revision);
        const requested = new Set(productChunk);
        for (const product of Array.isArray(data.products) ? data.products : []) {
          if (
            !requested.has(product?.productGid) ||
            !Array.isArray(product.listIds) ||
            !product.listIds.every((listId) => typeof listId === "string") ||
            generations.get(product.productGid) !==
              generationFor(state.membershipGenerations, product.productGid)
          ) {
            continue;
          }
          state.membership.set(product.productGid, [...new Set(product.listIds)]);
        }
      }
      if (ownerEpoch !== state.ownerEpoch) throw new WishlistOwnerChangedError();
      persistGuestRevision();
    }

    async function readVisibleCounts(productGids) {
      if (root.dataset.countEnabled !== "true") return;
      for (const productChunk of chunks(normalizeProductGids(productGids), 250)) {
        const generations = new Map(
          productChunk.map((productGid) => [
            productGid,
            generationFor(state.countGenerations, productGid),
          ]),
        );
        const data = await request("/counts", {
          method: "POST",
          body: { products: productChunk },
        });
        const requested = new Set(productChunk);
        for (const product of Array.isArray(data.products) ? data.products : []) {
          if (
            requested.has(product?.productGid) &&
            state.pendingProductToggles.get(product.productGid)?.confirmed !== false &&
            Number.isSafeInteger(product.displayCount) &&
            product.displayCount >= 0 &&
            generations.get(product.productGid) ===
              generationFor(state.countGenerations, product.productGid)
          ) {
            state.counts.set(product.productGid, product.displayCount);
          }
        }
      }
    }

    const knownWishlistControls = new WeakMap();

    function rememberWishlistControl(button) {
      const productGid = button.dataset.productGid || "";
      if (knownWishlistControls.get(button) === productGid) return false;
      knownWishlistControls.set(button, productGid);
      return true;
    }

    function relocateCardButton(button) {
      rememberWishlistControl(button);
      const card = button.closest(".hdt-card-product");
      const media = card?.querySelector(".hdt-card-product__media");
      if (!media) return;
      button.classList.add("cielohuk-wishlist-button--card");
      if (button.parentElement !== media) media.append(button);
    }

    function updateButton(button) {
      const productGid = button.dataset.productGid;
      if (!productGid) return;
      relocateCardButton(button);
      const pending = state.pendingProductToggles.get(productGid);
      if (!pending && !state.membership.has(productGid)) {
        if (button.dataset.cielohukWishlistHydration === "error") return;
        button.dataset.cielohukWishlistHydration = "pending";
        button.setAttribute("action", "loading");
        button.setAttribute("aria-busy", "true");
        button.removeAttribute("aria-pressed");
        delete button.dataset.included;
        button.disabled = true;
        button.setAttribute("aria-label", strings.loading);
        const countNode = button.querySelector("[data-cielohuk-wishlist-count]");
        if (countNode) countNode.hidden = true;
        return;
      }
      const included = pending ? pending.included : (state.membership.get(productGid) || []).length > 0;
      const label = included ? strings.remove : strings.add;
      const count = pending ? pending.count : state.counts.get(productGid);
      const threshold = Number(root.dataset.countThreshold || 0);
      const countNode = button.querySelector("[data-cielohuk-wishlist-count]");
      const safeCount = Number.isSafeInteger(count) && count >= 0 ? count : 0;
      const showCount = root.dataset.countEnabled === "true" && safeCount > 0 && safeCount >= threshold;
      button.setAttribute("aria-pressed", included ? "true" : "false");
      button.setAttribute("action", included ? "added" : "add");
      button.dataset.included = included ? "true" : "false";
      const labelNode = button.querySelector("[data-cielohuk-wishlist-label]");
      if (labelNode) labelNode.textContent = label;
      if (countNode) {
        countNode.textContent = String(safeCount);
        countNode.hidden = !showCount;
      }
      const countLabel = showCount ? `, ${formatText(strings.publicCount, { count: safeCount })}` : "";
      button.setAttribute("aria-label", `${label}${countLabel}`);
      button.dataset.cielohukWishlistHydration = "ready";
      button.disabled = Boolean(pending);
      if (pending) button.setAttribute("aria-busy", "true");
      else button.removeAttribute("aria-busy");
    }

    function updateAllButtons() {
      document.querySelectorAll("[data-cielohuk-wishlist-toggle]").forEach(updateButton);
    }

    function markProductControlsUnavailable(buttons = document.querySelectorAll("[data-cielohuk-wishlist-toggle]")) {
      buttons.forEach((button) => {
        if (button.dataset.cielohukWishlistHydration !== "pending") return;
        relocateCardButton(button);
        button.dataset.cielohukWishlistHydration = "error";
        button.setAttribute("action", "error");
        button.removeAttribute("aria-pressed");
        button.removeAttribute("aria-busy");
        delete button.dataset.included;
        button.disabled = true;
        const labelNode = button.querySelector("[data-cielohuk-wishlist-label]");
        const countNode = button.querySelector("[data-cielohuk-wishlist-count]");
        if (labelNode) labelNode.textContent = strings.unavailable;
        if (countNode) countNode.hidden = true;
        button.setAttribute("aria-label", strings.unavailable);
      });
    }

    async function hydrateProductControlsPass() {
      const buttons = [...document.querySelectorAll("[data-cielohuk-wishlist-toggle]")];
      buttons.forEach(rememberWishlistControl);
      buttons.forEach(relocateCardButton);
      const productGids = normalizeProductGids(buttons.map((button) => button.dataset.productGid));
      if (productGids.length === 0) return;
      try {
        const membership = state.authenticated || state.guestToken || state.ownerType
          ? ensureReady().then(() => {
              const missingProductGids = productGids.filter(
                (productGid) => !state.membership.has(productGid),
              );
              return readVisibleMembership(missingProductGids);
            })
          : Promise.resolve().then(() => {
              productGids.forEach((productGid) => setKnownMembership(productGid, []));
            });
        const missingCountProductGids = productGids.filter(
          (productGid) => !state.counts.has(productGid),
        );
        const results = await Promise.allSettled([
          membership.then(updateAllButtons),
          readVisibleCounts(missingCountProductGids).then(updateAllButtons),
        ]);
        if (results[0].status === "rejected") {
          if (results[0].reason instanceof WishlistOwnerChangedError) {
            state.hydrateRequested = true;
            return;
          }
          markProductControlsUnavailable(buttons);
          throw results[0].reason;
        }
        updateAllButtons();
      } catch (error) {
        setStatus(messageForError(error), true);
      }
    }

    function hydrateProductControls() {
      state.hydrateRequested = true;
      if (state.hydratePromise) return state.hydratePromise;
      const pending = (async () => {
        while (state.hydrateRequested) {
          state.hydrateRequested = false;
          await hydrateProductControlsPass();
        }
      })().finally(() => {
        if (state.hydratePromise !== pending) return;
        state.hydratePromise = null;
        if (state.hydrateRequested) void hydrateProductControls();
      });
      state.hydratePromise = pending;
      return pending;
    }

    function scheduleHydrate() {
      window.clearTimeout(state.hydrateTimer);
      state.hydrateTimer = window.setTimeout(() => {
        state.hydrateTimer = null;
        void hydrateProductControls();
      }, 40);
    }

    async function itemMutation(method, listId, product, allowRetry = true) {
      const ownerEpoch = state.ownerEpoch;
      try {
        const body = {
          productGid: product.productGid,
          expectedRevision: state.revision,
        };
        if (method === "PUT") {
          body.preferredVariantGid = product.preferredVariantGid || null;
          body.productHandle = product.productHandle || null;
          body.source = product.source || "card";
        }
        const result = await request(`/lists/${encodeURIComponent(listId)}/items`, {
          method,
          idempotencyKey: idempotencyKey(method === "PUT" ? "wishlist-add" : "wishlist-remove"),
          body,
        });
        if (ownerEpoch !== state.ownerEpoch) throw new WishlistOwnerChangedError();
        commitRevision(result.revision);
        persistGuestRevision();
        return result;
      } catch (error) {
        if (ownerEpoch !== state.ownerEpoch) throw new WishlistOwnerChangedError();
        if (
          allowRetry &&
          error instanceof WishlistApiError &&
          error.code === "stale_revision"
        ) {
          const currentRevision = Number(error.details.currentRevision);
          await loadLists(Number.isSafeInteger(currentRevision) ? currentRevision : 0, { force: true });
          return itemMutation(method, listId, product, false);
        }
        throw error;
      }
    }

    async function deleteProductMutation(productGid, allowRetry = true) {
      const ownerEpoch = state.ownerEpoch;
      try {
        const result = await request("/items", {
          method: "DELETE",
          idempotencyKey: idempotencyKey("wishlist-remove-all"),
          body: {
            productGid,
            expectedRevision: state.revision,
          },
        });
        if (ownerEpoch !== state.ownerEpoch) throw new WishlistOwnerChangedError();
        commitRevision(result.revision);
        persistGuestRevision();
        return result;
      } catch (error) {
        if (ownerEpoch !== state.ownerEpoch) throw new WishlistOwnerChangedError();
        if (
          allowRetry &&
          error instanceof WishlistApiError &&
          error.code === "stale_revision"
        ) {
          const currentRevision = Number(error.details.currentRevision);
          await loadLists(Number.isSafeInteger(currentRevision) ? currentRevision : 0, { force: true });
          return deleteProductMutation(productGid, false);
        }
        throw error;
      }
    }

    function enqueueMutation(operation) {
      const run = state.mutationQueue.catch(() => undefined).then(operation);
      state.mutationQueue = run.catch(() => undefined);
      return run;
    }

    function productFromButton(button) {
      return {
        productGid: button.dataset.productGid,
        productHandle: button.dataset.productHandle || null,
        preferredVariantGid: button.dataset.variantGid || null,
        source: button.dataset.source || "card",
      };
    }

    function beginProductToggle(button, included) {
      const productGid = button.dataset.productGid;
      if (!productGid || button.disabled || state.pendingProductToggles.has(productGid)) return null;
      const count = state.counts.get(productGid);
      const wasIncluded = (state.membership.get(productGid) || []).length > 0;
      const pending = {
        included,
        count: Number.isSafeInteger(count)
          ? count + (included && !wasIncluded ? 1 : 0)
          : undefined,
        ownerEpoch: state.ownerEpoch,
        confirmed: false,
      };
      // A count requested before this click must not undo its immediate feedback.
      bumpGeneration(state.countGenerations, productGid);
      state.pendingProductToggles.set(productGid, pending);
      updateAllButtons();
      return pending;
    }

    function finishProductToggle(button, pending) {
      const productGid = button.dataset.productGid;
      if (state.pendingProductToggles.get(productGid) !== pending) return;
      state.pendingProductToggles.delete(productGid);
      updateAllButtons();
    }

    async function addFromButton(button, pending = beginProductToggle(button, true)) {
      if (!pending) return;
      setStatus(strings.saving);
      try {
        await ensureReady();
        if (pending.ownerEpoch !== state.ownerEpoch) throw new WishlistOwnerChangedError();
        const product = productFromButton(button);
        const result = await itemMutation("PUT", state.defaultListId, product);
        pending.confirmed = true;
        const listIds = state.membership.get(product.productGid) || [];
        const previousCount = state.counts.get(product.productGid);
        setKnownMembership(product.productGid, [...listIds, state.defaultListId].filter(Boolean));
        setKnownCount(
          product.productGid,
          result.changed && listIds.length === 0 && Number.isSafeInteger(previousCount)
            ? previousCount + 1
            : previousCount,
        );
        updateOwnerTotals();
        updateAllButtons();
        setStatus(strings.saved);
        broadcastUpdate([product.productGid], state.revision);
        // Auxiliary reads must not keep a successfully saved heart busy or roll it back.
        void loadLists(result.revision)
          .then(() => { renderDrawer(); updateAllButtons(); })
          .catch(() => undefined);
        void readVisibleCounts([product.productGid]).then(updateAllButtons).catch(() => undefined);
      } catch (error) {
        if (pending.ownerEpoch === state.ownerEpoch) setStatus(messageForError(error), true);
      } finally {
        finishProductToggle(button, pending);
      }
    }

    async function removeProductEverywhere(button, pending = beginProductToggle(button, false)) {
      if (!pending) return;
      setStatus(strings.saving);
      try {
        await ensureReady();
        if (pending.ownerEpoch !== state.ownerEpoch) throw new WishlistOwnerChangedError();
        const product = productFromButton(button);
        await removeProductGidEverywhere(product.productGid);
      } catch (error) {
        if (pending.ownerEpoch === state.ownerEpoch) setStatus(messageForError(error), true);
      } finally {
        finishProductToggle(button, pending);
      }
    }

    function createElement(tagName, className, text) {
      const element = document.createElement(tagName);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    }

    function productPath(handle) {
      return new URL(
        `products/${encodeURIComponent(handle || "")}`,
        `${window.location.origin}${storefrontRoot}`,
      ).pathname;
    }

    function numericGid(gid) {
      const value = String(gid || "").split("/").pop();
      return /^\d+$/.test(value || "") ? value : null;
    }

    function formatMoney(cents) {
      if (!Number.isFinite(cents)) return "";
      try {
        return new Intl.NumberFormat(root.dataset.locale || "ja-JP", {
          style: "currency",
          currency: root.dataset.currency || "JPY",
        }).format(cents / 100);
      } catch {
        return String(cents);
      }
    }

    async function loadProduct(handle) {
      if (!handle) return null;
      if (!productCache.has(handle)) {
        productCache.set(
          handle,
          fetch(`${productPath(handle)}.js`, {
            headers: { accept: "application/json" },
            credentials: "same-origin",
            cache: "force-cache",
          })
            .then((response) => {
              if (!response.ok) throw new Error("product_unavailable");
              return response.json();
            })
            .catch(() => null),
        );
      }
      return productCache.get(handle);
    }

    function safeImageUrl(value) {
      if (typeof value !== "string" || value.length === 0) return null;
      try {
        const url = new URL(value, window.location.origin);
        return ["http:", "https:"].includes(url.protocol) ? url.href : null;
      } catch {
        return null;
      }
    }

    function configureWishlistCart(item, product, elements) {
      const variants = Array.isArray(product.variants) ? product.variants : [];
      const definitions = Array.isArray(product.options) ? product.options : [];
      const savedSelection = state.cartSelections.get(item.productGid) || [];
      const selectors = [];
      const onlyDefaultVariant = variants.length === 1 && variants[0].title === "Default Title";
      if (!onlyDefaultVariant) {
        definitions.forEach((definition, index) => {
          const values = [...new Set(variants.map((variant) => variant.options?.[index]))]
            .filter((value) => typeof value === "string" && value.length > 0);
          const label = createElement("label", "cielohuk-wishlist-variants__option");
          const name = createElement("span", "", definition.name);
          const select = createElement("select");
          select.required = true;
          select.dataset.cielohukVariantOption = String(index);
          if (values.length !== 1) {
            const placeholder = createElement("option", "", strings.chooseOptions);
            placeholder.value = "";
            select.append(placeholder);
          }
          for (const value of values) {
            const option = createElement("option", "", value);
            option.value = value;
            select.append(option);
          }
          select.value = values.includes(savedSelection[index])
            ? savedSelection[index]
            : values.length === 1 ? values[0] : "";
          label.append(name, select);
          elements.variantPicker.append(label);
          selectors.push(select);
        });
      }
      const availability = elements.availability || createElement("p", "cielohuk-wishlist-variants__status");
      availability.setAttribute("aria-live", "polite");
      if (!elements.availability) elements.variantPicker.append(availability);

      function updateVariant() {
        const complete = selectors.length > 0 && selectors.every((select) => select.value !== "");
        const variant = variants.length === 1
          ? variants[0]
          : complete
            ? variants.find((candidate) => selectors.every((select, index) => candidate.options?.[index] === select.value))
            : null;
        const available = Boolean(variant?.available);
        elements.variantInput.value = available ? String(variant.id) : "";
        elements.cartButton.disabled = !available;
        const status = variant
          ? available ? strings.inStock : strings.soldOut
          : !variants.some((candidate) => candidate.available)
            ? strings.soldOut
            : complete ? strings.variantUnavailable : strings.chooseOptions;
        availability.textContent = status;
        elements.cartButton.textContent = available || status === strings.chooseOptions
          ? strings.addToCart
          : status;
        elements.price.textContent = formatMoney(variant?.price ?? product.price);
        const imageUrl = safeImageUrl(variant?.featured_image?.src || product.featured_image);
        if (imageUrl) {
          const image = createElement("img");
          image.src = imageUrl;
          image.alt = product.title || "";
          image.loading = "lazy";
          elements.media.replaceChildren(image);
        }
        return available;
      }

      for (const select of selectors) {
        select.addEventListener("change", () => {
          state.cartSelections.set(item.productGid, selectors.map((selector) => selector.value));
          updateVariant();
        });
      }
      elements.cartForm.addEventListener("submit", (event) => {
        if (!updateVariant()) event.preventDefault();
      });
      updateVariant();
    }

    async function enrichDrawerItem(item, elements) {
      const product = await loadProduct(item.productHandle);
      if (!product) {
        elements.cartButton.textContent = strings.variantUnavailable;
        return;
      }
      elements.title.textContent = product.title || item.productHandle;
      configureWishlistCart(item, product, elements);
    }

    function createQuantityControl(className = "cielohuk-wishlist-quantity") {
      const wrapper = createElement("div", className);
      wrapper.dataset.cielohukQuantity = "true";
      const decrease = createElement("button", "", "−");
      decrease.type = "button";
      decrease.dataset.cielohukQuantityStep = "-1";
      decrease.setAttribute("aria-label", strings.decreaseQuantity);
      const input = createElement("input");
      input.type = "number";
      input.name = "quantity";
      input.min = "1";
      input.step = "1";
      input.inputMode = "numeric";
      input.value = "1";
      input.setAttribute("aria-label", strings.quantity);
      const increase = createElement("button", "", "+");
      increase.type = "button";
      increase.dataset.cielohukQuantityStep = "1";
      increase.setAttribute("aria-label", strings.increaseQuantity);
      wrapper.append(decrease, input, increase);
      return { wrapper, input };
    }

    function drawerItem(item, enrichmentAllowed) {
      const row = createElement("li", "cielohuk-wishlist-item");
      row.dataset.productGid = item.productGid;
      const media = createElement("div", "cielohuk-wishlist-item__media");
      const content = createElement("div", "cielohuk-wishlist-item__content");
      const title = createElement("a", "cielohuk-wishlist-item__title", (item.productHandle || "").replaceAll("-", " "));
      title.href = productPath(item.productHandle);
      const price = createElement("p", "cielohuk-wishlist-item__price", "");
      const actions = createElement("div", "cielohuk-wishlist-item__actions");
      const viewLink = createElement("a", "cielohuk-wishlist-item__view", strings.viewProduct);
      viewLink.href = productPath(item.productHandle);
      const remove = createElement("button", "cielohuk-wishlist-item__remove", strings.removeItem);
      remove.type = "button";
      remove.dataset.cielohukWishlistRemoveAll = "true";
      remove.dataset.productGid = item.productGid;
      const cartForm = createElement("form", "cielohuk-wishlist-item__cart");
      cartForm.method = "post";
      cartForm.action = root.dataset.cartAddUrl || "/cart/add";
      const variantInput = createElement("input");
      variantInput.type = "hidden";
      variantInput.name = "id";
      const variantPicker = createElement("div", "cielohuk-wishlist-variants");
      const quantity = createQuantityControl();
      const cartButton = createElement("button", "", strings.addToCart);
      cartButton.type = "submit";
      cartButton.disabled = true;
      cartForm.append(variantInput, variantPicker, quantity.wrapper, cartButton);
      actions.append(viewLink, remove, cartForm);
      content.append(title, price, actions);
      row.append(media, content);

      if (enrichmentAllowed) {
        void enrichDrawerItem(item, { media, title, price, variantInput, variantPicker, cartForm, cartButton });
      }
      return row;
    }

    function renderDrawer() {
      if (!listContainer) return;
      listContainer.replaceChildren();
      const panel = createElement("div", "cielohuk-wishlist-list cielohuk-wishlist-list--single");
      const products = orderedWishlistProducts();
      let enrichmentCount = 0;
      if (products.length === 0) {
        panel.append(createElement("p", "cielohuk-wishlist-list__empty", strings.emptyList));
      } else {
        const items = createElement("ul", "cielohuk-wishlist-items");
        for (const item of products) {
          const allowEnrichment = productCache.has(item.productHandle) || enrichmentCount < 30;
          if (!productCache.has(item.productHandle) && allowEnrichment) enrichmentCount += 1;
          items.append(drawerItem(item, allowEnrichment));
        }
        panel.append(items);
      }
      listContainer.append(panel);
      updateOwnerTotals();
      if (drawer?.open && !drawer.contains(document.activeElement)) {
        drawer.querySelector("[data-cielohuk-wishlist-close]")?.focus({ preventScroll: true });
      }
    }

    async function openDrawer(opener, productGid = null) {
      if (!drawer) return;
      state.opener = opener || document.activeElement;
      state.focusedProductGid = productGid;
      state.restoreFocus = true;
      if (!drawer.open) {
        if (typeof drawer.showModal === "function") drawer.showModal();
        else drawer.setAttribute("open", "");
      }
      document.body.classList.add("cielohuk-wishlist-drawer-open");
      if (state.listsLoadedAt > 0) {
        renderDrawer();
        setStatus("");
      } else {
        setStatus(strings.loading);
      }
      if (state.drawerLoadPromise) return state.drawerLoadPromise;
      drawer.setAttribute("aria-busy", "true");
      const pending = (async () => {
        try {
          await ensureReady();
          if (Date.now() - state.listsLoadedAt > 15000) {
            await loadLists(state.revision, { force: true });
          }
          renderDrawer();
          setStatus("");
        } catch (error) {
          let currentError = error;
          if (
            currentError instanceof WishlistOwnerChangedError &&
            (state.authenticated || state.guestToken || state.ownerType)
          ) {
            try {
              const activeRefresh = state.refreshPromise;
              const recovered = activeRefresh ? await activeRefresh : (await ensureReady(), true);
              const recoveredOwnerEpoch = state.ownerEpoch;
              const recoveredReady = state.ready;
              if (
                !recovered ||
                !state.ownerType ||
                (!state.authenticated && !state.guestToken) ||
                !recoveredReady ||
                state.listsLoadedAt <= 0
              ) {
                throw currentError;
              }
              await recoveredReady;
              if (
                state.ownerEpoch !== recoveredOwnerEpoch ||
                state.ready !== recoveredReady ||
                !state.ownerType ||
                (!state.authenticated && !state.guestToken) ||
                state.listsLoadedAt <= 0
              ) {
                throw currentError;
              }
              renderDrawer();
              setStatus("");
              return;
            } catch (recoveryError) {
              currentError = recoveryError;
            }
          }
          setStatus(messageForError(currentError), true);
        } finally {
          drawer.removeAttribute("aria-busy");
          if (state.drawerLoadPromise === pending) state.drawerLoadPromise = null;
        }
      })();
      state.drawerLoadPromise = pending;
      return pending;
    }

    function closeDrawer(restoreFocus = true) {
      if (!drawer) return;
      state.restoreFocus = restoreFocus;
      if (typeof drawer.close === "function") drawer.close();
      else drawer.removeAttribute("open");
    }

    function drawerFocusableElements() {
      if (!drawer) return [];
      const selector = [
        "a[href]",
        "button:not([disabled])",
        "input:not([disabled])",
        "select:not([disabled])",
        "textarea:not([disabled])",
        '[tabindex]:not([tabindex="-1"])',
      ].join(",");
      return [...drawer.querySelectorAll(selector)].filter(
        (element) =>
          element instanceof HTMLElement &&
          !element.hidden &&
          !element.closest('[hidden], [aria-hidden="true"]') &&
          element.getClientRects().length > 0,
      );
    }

    function trapDrawerFocus(event) {
      if (event.key !== "Tab" || !drawer?.open) return;
      const focusable = drawerFocusableElements();
      if (focusable.length === 0) {
        event.preventDefault();
        drawer.focus({ preventScroll: true });
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const active = document.activeElement;
      if (event.shiftKey && (active === first || !drawer.contains(active))) {
        event.preventDefault();
        last.focus({ preventScroll: true });
      } else if (!event.shiftKey && (active === last || !drawer.contains(active))) {
        event.preventDefault();
        first.focus({ preventScroll: true });
      }
    }

    function orderedWishlistProducts() {
      const seen = new Set();
      const products = [];
      for (const list of state.lists) {
        for (const item of list.items || []) {
          if (!seen.has(item.productGid)) {
            seen.add(item.productGid);
            products.push(item);
          }
        }
      }
      return products;
    }

    async function enrichWishlistPageItem(item, elements) {
      const product = await loadProduct(item.productHandle);
      if (!product) {
        elements.availability.textContent = strings.variantUnavailable;
        return;
      }
      const path = productPath(item.productHandle);
      elements.title.textContent = product.title || item.productHandle;
      elements.title.href = path;
      elements.media.href = path;
      elements.view.href = path;
      configureWishlistCart(item, product, elements);
    }

    function wishlistPageItem(item) {
      const row = createElement("li", "cielohuk-wishlist-page__item");
      row.dataset.productGid = item.productGid;
      const media = createElement("a", "cielohuk-wishlist-page__media");
      media.href = productPath(item.productHandle);
      media.setAttribute("aria-label", strings.viewProduct);
      const content = createElement("div", "cielohuk-wishlist-page__content");
      const title = createElement(
        "a",
        "cielohuk-wishlist-page__title",
        (item.productHandle || "").replaceAll("-", " "),
      );
      title.href = productPath(item.productHandle);
      const price = createElement("p", "cielohuk-wishlist-page__price", "");
      const availability = createElement("p", "cielohuk-wishlist-page__availability", strings.pageLoading);
      const actions = createElement("div", "cielohuk-wishlist-page__actions");
      const links = createElement("div", "cielohuk-wishlist-page__links");
      const view = createElement("a", "cielohuk-wishlist-page__view", strings.viewProduct);
      view.href = productPath(item.productHandle);
      const remove = createElement("button", "cielohuk-wishlist-page__remove", strings.removeItem);
      remove.type = "button";
      remove.dataset.cielohukWishlistRemoveAll = "true";
      remove.dataset.productGid = item.productGid;
      const cartForm = createElement("form", "cielohuk-wishlist-page__cart");
      cartForm.method = "post";
      cartForm.action = root.dataset.cartAddUrl || "/cart/add";
      const variantInput = createElement("input");
      variantInput.type = "hidden";
      variantInput.name = "id";
      const variantPicker = createElement("div", "cielohuk-wishlist-variants");
      const quantity = createQuantityControl();
      const cartButton = createElement("button", "", strings.addToCart);
      cartButton.type = "submit";
      cartButton.disabled = true;
      cartForm.append(variantInput, variantPicker, quantity.wrapper, cartButton);
      links.append(view, remove);
      actions.append(links, cartForm);
      content.append(title, price, availability, actions);
      row.append(media, content);
      void enrichWishlistPageItem(item, {
        media,
        title,
        price,
        availability,
        view,
        variantInput,
        variantPicker,
        cartForm,
        cartButton,
      });
      return row;
    }

    function renderWishlistPagination(container, currentPage, totalPages) {
      if (!container) return;
      container.replaceChildren();
      if (totalPages <= 1) return;
      const previous = createElement("button", "", strings.previousPage);
      previous.type = "button";
      previous.disabled = currentPage <= 1;
      previous.addEventListener("click", () => {
        state.pageNumber = Math.max(1, currentPage - 1);
        void syncWishlistPage();
      });
      const status = createElement("span", "", formatText(strings.pageStatus, { current: currentPage, total: totalPages }));
      const next = createElement("button", "", strings.nextPage);
      next.type = "button";
      next.disabled = currentPage >= totalPages;
      next.addEventListener("click", () => {
        state.pageNumber = Math.min(totalPages, currentPage + 1);
        void syncWishlistPage();
      });
      container.append(previous, status, next);
    }

    async function syncWishlistPage() {
      const page = document.querySelector("[data-cielohuk-wishlist-page]");
      if (!page) return;
      const loading = page.querySelector("[data-cielohuk-wishlist-page-loading]");
      const feedback = page.querySelector("[data-cielohuk-wishlist-page-feedback]");
      const empty = page.querySelector("[data-cielohuk-wishlist-page-empty]");
      const items = page.querySelector("[data-cielohuk-wishlist-page-items]");
      const pagination = page.querySelector("[data-cielohuk-wishlist-pagination]");
      const summary = page.querySelector("[data-cielohuk-wishlist-page-summary]");
      const products = orderedWishlistProducts();
      if (summary) summary.textContent = formatText(strings.pageSummary, { count: products.length });
      if (products.length === 0) {
        if (items) {
          items.hidden = true;
          items.replaceChildren();
        }
        if (empty) empty.hidden = false;
        if (loading) loading.hidden = true;
        if (feedback) feedback.hidden = true;
        page.dataset.ready = "true";
        state.pageNumber = 1;
        renderWishlistPagination(pagination, 1, 1);
        return;
      }
      if (empty) empty.hidden = true;
      const totalPages = Math.max(1, Math.ceil(products.length / pageSize));
      state.pageNumber = Math.min(Math.max(state.pageNumber, 1), totalPages);
      const selected = products.slice(
        (state.pageNumber - 1) * pageSize,
        state.pageNumber * pageSize,
      );
      if (items) {
        items.replaceChildren(...selected.map(wishlistPageItem));
        items.hidden = false;
      }
      renderWishlistPagination(pagination, state.pageNumber, totalPages);
      if (loading) loading.hidden = true;
      if (feedback) feedback.hidden = true;
      page.dataset.ready = "true";
    }

    function broadcastUpdate(productGids = [], revision = state.revision) {
      if (!channel) return;
      const message = {
        type: "wishlist-updated",
        productGids: normalizeProductGids(productGids),
      };
      if (Number.isSafeInteger(revision) && revision >= 0) message.revision = revision;
      channel.postMessage(message);
    }

    async function removeProductGidEverywhere(productGid) {
      await ensureReady();
      const result = await deleteProductMutation(productGid);
      const pending = state.pendingProductToggles.get(productGid);
      if (pending) pending.confirmed = true;
      const previousCount = state.counts.get(productGid);
      for (const list of state.lists) {
        if (Array.isArray(list.items)) {
          list.items = list.items.filter((item) => item.productGid !== productGid);
        }
      }
      // An earlier add may still be refreshing this cache; do not mark it complete.
      state.listsLoadedAt = 0;
      setKnownMembership(productGid, []);
      // Hearts measure cumulative interest, so removing an item keeps its public count.
      setKnownCount(productGid, previousCount);
      updateOwnerTotals();
      renderDrawer();
      updateAllButtons();
      setStatus(strings.itemRemoved);
      broadcastUpdate([productGid], state.revision);
      await syncWishlistPage();
      void loadLists(result.revision)
        .then(async () => {
          renderDrawer();
          updateAllButtons();
          await syncWishlistPage();
        })
        .catch(() => undefined);
      void readVisibleCounts([productGid])
        .then(updateAllButtons)
        .catch(() => undefined);
    }

    async function refreshFromServerPass(minimumRevision, forceAfterSerial) {
      const ownerEpoch = state.ownerEpoch;
      const page = document.querySelector("[data-cielohuk-wishlist-page]");
      const feedback = page?.querySelector("[data-cielohuk-wishlist-page-feedback]");
      const loading = page?.querySelector("[data-cielohuk-wishlist-page-loading]");
      const pageRetry = page?.querySelector("[data-cielohuk-wishlist-retry]");
      const previousMembership = membershipSnapshotFromLists();
      if (feedback) feedback.hidden = false;
      if (loading) {
        loading.hidden = false;
        loading.textContent = strings.pageLoading;
      }
      if (pageRetry) pageRetry.hidden = true;
      try {
        await ensureReady();
        const ownerChanged = ownerEpoch !== state.ownerEpoch;
        await loadLists(ownerChanged ? 0 : minimumRevision, {
          forceAfterSerial: ownerChanged ? null : forceAfterSerial,
        });
        const changedProductGids = takeUnprocessedExternalProductGids(
          ownerChanged
            ? []
            : changedMembershipProductGids(previousMembership, membershipSnapshotFromLists()),
          state.listsRevision,
        );
        invalidateCounts(changedProductGids);
        renderDrawer();
        updateAllButtons();
        scheduleHydrate();
        await syncWishlistPage();
        return true;
      } catch (error) {
        if (error instanceof WishlistOwnerChangedError) {
          if (!state.authenticated && !state.guestToken) {
            state.refreshRequested = false;
            return false;
          }
          state.refreshForceAfterSerial = Math.max(
            state.refreshForceAfterSerial ?? -1,
            state.listLoadSerial,
          );
          state.refreshRequested = true;
          return null;
        }
        setStatus(messageForError(error), true);
        if (page) page.dataset.ready = "true";
        if (loading) loading.textContent = messageForError(error);
        if (pageRetry) pageRetry.hidden = false;
        return false;
      }
    }

    function refreshFromServer(options = {}) {
      const minimumRevision = Number.isSafeInteger(options.minimumRevision) && options.minimumRevision >= 0
        ? options.minimumRevision
        : 0;
      state.refreshMinimumRevision = Math.max(state.refreshMinimumRevision, minimumRevision);
      if (options.forceLists !== false) {
        state.refreshForceAfterSerial = Math.max(
          state.refreshForceAfterSerial ?? -1,
          state.listLoadSerial,
        );
      }
      state.refreshRequested = true;
      if (state.refreshPromise) return state.refreshPromise;
      const pending = (async () => {
        let succeeded = false;
        while (state.refreshRequested) {
          state.refreshRequested = false;
          const nextMinimumRevision = state.refreshMinimumRevision;
          const nextForceAfterSerial = state.refreshForceAfterSerial;
          state.refreshMinimumRevision = 0;
          state.refreshForceAfterSerial = null;
          succeeded = (await refreshFromServerPass(nextMinimumRevision, nextForceAfterSerial)) === true;
        }
        return succeeded;
      })().finally(() => {
        if (state.refreshPromise !== pending) return;
        state.refreshPromise = null;
        if (state.refreshRequested) void refreshFromServer({ forceLists: false });
      });
      state.refreshPromise = pending;
      return pending;
    }

    function receiveExternalUpdate(payload = {}) {
      const revision = Number.isSafeInteger(payload.revision) && payload.revision >= 0
        ? payload.revision
        : null;
      const productGids = normalizeProductGids(payload.productGids);
      if (revision !== null) {
        state.externalUpdateRevision = Math.max(state.externalUpdateRevision, revision);
        const invalidatedProductGids = takeUnprocessedExternalProductGids(productGids, revision);
        invalidateMembership(invalidatedProductGids, true);
        invalidateCounts(invalidatedProductGids);
      } else {
        const invalidatedProductGids = productGids.length > 0 ? productGids : visibleProductGids();
        invalidateMembership(invalidatedProductGids, true);
        invalidateCounts(invalidatedProductGids);
      }
      void refreshFromServer({
        minimumRevision: revision === null ? 0 : state.externalUpdateRevision,
        forceLists: revision === null,
      });
    }

    const channel = "BroadcastChannel" in window ? new BroadcastChannel("cielohuk-wishlist-v1") : null;
    if (channel) {
      channel.addEventListener("message", (event) => {
        if (event.data?.type === "wishlist-updated") receiveExternalUpdate(event.data);
      });
    }

    document.addEventListener("click", (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const quantityStep = target?.closest("[data-cielohuk-quantity-step]");
      if (quantityStep) {
        event.preventDefault();
        const quantity = quantityStep
          .closest("[data-cielohuk-quantity]")
          ?.querySelector("input[name='quantity']");
        if (quantity instanceof HTMLInputElement) {
          const current = Number.parseInt(quantity.value, 10);
          const step = Number.parseInt(quantityStep.dataset.cielohukQuantityStep || "0", 10);
          quantity.value = String(Math.max(1, (Number.isFinite(current) ? current : 1) + step));
        }
        return;
      }

      const pageRemove = target?.closest("[data-cielohuk-wishlist-remove-all]");
      if (pageRemove) {
        const productGid = pageRemove.dataset.productGid;
        if (!productGid) return;
        pageRemove.disabled = true;
        pageRemove.setAttribute("aria-busy", "true");
        void enqueueMutation(async () => {
          setStatus(strings.saving);
          try {
            await removeProductGidEverywhere(productGid);
          } catch (error) {
            setStatus(messageForError(error), true);
            pageRemove.disabled = false;
            pageRemove.removeAttribute("aria-busy");
          }
        });
        return;
      }

      const toggle = target?.closest("[data-cielohuk-wishlist-toggle]");
      if (toggle) {
        event.preventDefault();
        event.stopPropagation();
        const included = !toggle.hasAttribute("data-wishlist-remove-on-page") && toggle.dataset.included !== "true";
        const pending = beginProductToggle(toggle, included);
        if (pending) void enqueueMutation(() => included
          ? addFromButton(toggle, pending)
          : removeProductEverywhere(toggle, pending));
        return;
      }

      const launcher = target?.closest("[data-cielohuk-wishlist-open]");
      if (launcher) {
        event.preventDefault();
        void openDrawer(launcher);
        return;
      }

      if (target?.closest("[data-cielohuk-wishlist-retry]")) {
        void refreshFromServer();
        return;
      }

      if (target?.closest("[data-cielohuk-wishlist-close]")) {
        closeDrawer();
        return;
      }

    });

    document.addEventListener("change", (event) => {
      const field = event.target instanceof Element ? event.target.closest("[name='id']") : null;
      if (!field) return;
      window.queueMicrotask(() => {
        const scope = field.closest("form")?.closest("section, [id*='Product'], hdt-quick-view") || document;
        scope.querySelectorAll("[data-cielohuk-wishlist-toggle]").forEach((button) => {
          const value = field.value;
          if (/^\d+$/.test(value)) button.dataset.variantGid = `gid://shopify/ProductVariant/${value}`;
        });
      });
    });

    if (drawer) {
      drawer.addEventListener("keydown", trapDrawerFocus);
      drawer.addEventListener("click", (event) => {
        if (event.target === drawer) closeDrawer();
      });
      drawer.addEventListener("close", () => {
        document.body.classList.remove("cielohuk-wishlist-drawer-open");
        if (state.restoreFocus && state.opener instanceof HTMLElement) state.opener.focus({ preventScroll: true });
        state.restoreFocus = true;
      });
    }

    window.addEventListener("storage", (event) => {
      if (![guestSessionKey, legacyGuestTokenKey, guestRevisionKey].includes(event.key)) return;
      if ([guestSessionKey, legacyGuestTokenKey].includes(event.key)) {
        const next = readGuestSession();
        const changed =
          next.token !== state.guestToken ||
          next.version !== state.guestTokenVersion ||
          next.defaultListId !== state.guestDefaultListId;
        if (!changed) return;
        if (!next.token) {
          applyGuestSession(next);
          if (state.authenticated || state.ownerType === "customer") return;
          resetOwnerState();
          state.refreshRequested = false;
          updateAllButtons();
          void syncWishlistPage();
          return;
        }
        if (
          next.token === state.guestToken &&
          next.version === state.guestTokenVersion &&
          next.defaultListId &&
          (!state.guestDefaultListId || next.defaultListId === state.guestDefaultListId)
        ) {
          applyGuestSession(next);
          return;
        }
        const currentDefaultListId =
          state.guestDefaultListId || (state.ownerType === "guest" ? state.defaultListId : null);
        if (currentDefaultListId && next.defaultListId === currentDefaultListId) {
          if (next.version < state.guestTokenVersion) return;
          if (next.version > state.guestTokenVersion) {
            applyGuestSession(next);
            return;
          }
        }
        if (
          currentDefaultListId &&
          !next.defaultListId &&
          state.guestToken &&
          next.version > state.guestTokenVersion
        ) {
          const enriched = { ...next, defaultListId: currentDefaultListId };
          applyGuestSession(enriched);
          writeStorage(guestSessionKey, JSON.stringify(enriched));
          writeStorage(legacyGuestTokenKey, null);
          return;
        }
        applyGuestSession(next);
        resetOwnerState();
        void refreshFromServer({ forceLists: true });
        return;
      }
      const revision = Number(event.newValue);
      if (Number.isSafeInteger(revision) && revision >= 0) {
        receiveExternalUpdate({ type: "wishlist-updated", revision });
      }
    });
    document.addEventListener("shopify:section:load", scheduleHydrate);

    function discoverWishlistControls(node) {
      if (!(node instanceof Element)) return false;
      const buttons = [];
      if (node.matches("[data-cielohuk-wishlist-toggle]")) buttons.push(node);
      node.querySelectorAll("[data-cielohuk-wishlist-toggle]").forEach((button) => buttons.push(button));
      let discovered = false;
      for (const button of buttons) {
        if (rememberWishlistControl(button)) discovered = true;
      }
      return discovered;
    }

    new MutationObserver((records) => {
      let hasNewWishlistControl = false;
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (discoverWishlistControls(node)) hasNewWishlistControl = true;
        }
      }
      if (hasNewWishlistControl) scheduleHydrate();
    }).observe(document.body, { childList: true, subtree: true });

    const hasWishlistPage = Boolean(document.querySelector("[data-cielohuk-wishlist-page]"));
    // Start public counts alongside owner loading, and enable hearts as soon as membership is known.
    void hydrateProductControls();
    const existingOwnerReady =
      state.authenticated || state.guestToken || hasWishlistPage
        ? ensureReady()
        : Promise.resolve();
    void existingOwnerReady
      .then(async () => {
        setStatus("");
        renderDrawer();
        await syncWishlistPage();
      })
      .catch((error) => {
        markProductControlsUnavailable();
        setStatus(messageForError(error), true);
        const page = document.querySelector("[data-cielohuk-wishlist-page]");
        const loading = page?.querySelector("[data-cielohuk-wishlist-page-loading]");
        const retry = page?.querySelector("[data-cielohuk-wishlist-retry]");
        if (loading) loading.textContent = strings.unavailable;
        if (retry) retry.hidden = false;
        if (page) page.dataset.ready = "true";
      });
  })();
  } catch(e) { console.error(e); }
})();

})();
